import Vue from 'vue'
import Router from 'vue-router'
import paths from './paths'
import * as utils from './utils'
import { goBack } from '@/utils/navigation'

Vue.use(Router)
const router = new Router(paths)

router.goBack = goBack

router.beforeEach(utils.compensateAbortedPageLoading)
router.beforeEach(utils.loadSystemSettings)
router.beforeEach(utils.checkFeatureStatus)
router.beforeEach(utils.handleHomeLogin)
router.beforeEach(utils.checkUserType)
router.beforeEach(utils.checkPermission)
router.beforeEach(utils.checkTenancyRecordAccess)

router.beforeEach(utils.checkFormDirty)
router.beforeEach(utils.workPermitBatchApproveCheck)
router.beforeEach(utils.prePageLoaded) /* Last before-each interceptor for rourter */

router.afterEach(utils.postPageLoaded) /* First after-each interceptor for rourter */
router.afterEach(utils.setupPage)
router.afterEach(utils.getAllBuildingsAfterLogin)
router.afterEach(utils.getCurrenciesAfterLogin)
router.onError(utils.postPageLoaded)

export default router
